import * as React from 'react';
import { useTranslator } from '@gandi/translate';
import { Base, BlockHeading, IconButton } from '@gandi/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SectionHeader = ({
  title,
  onEditToggle,
  readOnlyMode,
  disabled
}) => {
  const {
    __
  } = useTranslator();
  return /*#__PURE__*/_jsxs(BlockHeading, {
    flexJustifyBetween: true,
    flexAlignItemsStart: true,
    flexWrap: false,
    flexAlignItemsCenter: false,
    children: [title, readOnlyMode && /*#__PURE__*/_jsx(Base, {
      slot: "headingEnd",
      children: /*#__PURE__*/_jsx(IconButton, {
        disabled: disabled,
        type: "button",
        icon: "pen",
        shape: "circle",
        kind: "outline",
        small: true,
        onClick: onEditToggle
        // requires https://gitlab.corp.gandi.net/admin-v5/gandi.react-libs/merge_requests/1331
        // a11yTitleId={v4()}
        ,
        "aria-label": __('Toggle edit %(title)s', {
          title
        }),
        children: __('Toggle edit %(title)s', {
          title
        })
      })
    })]
  });
};
export default SectionHeader;